import EstablecimientoModal from "./EstablecimientoModal";
export default EstablecimientoModal;